"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformLinkingProvider = void 0;
// Note. Keep values in sync with `PlatformType`.
var PlatformLinkingProvider;
(function (PlatformLinkingProvider) {
    PlatformLinkingProvider["LeagueOfLegends"] = "leagueOfLegends";
    PlatformLinkingProvider["Steam"] = "steam";
    PlatformLinkingProvider["Lichess"] = "lichess";
    PlatformLinkingProvider["Lidraughts"] = "lidraughts";
    PlatformLinkingProvider["EvIo"] = "evio";
    PlatformLinkingProvider["Papergames"] = "papergames";
    PlatformLinkingProvider["Paypal"] = "paypal";
})(PlatformLinkingProvider = exports.PlatformLinkingProvider || (exports.PlatformLinkingProvider = {}));
//# sourceMappingURL=platform-linking-provider.js.map